"use client";
import React, { useEffect, useState } from "react";

import Lottie from "react-lottie";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import searchProcessingAnimation from "../lottie/Search Processing.json";
import typingAnimation from "../lottie/typingAnimation.json";

const CompanyHistory = ({ companyHistoryData = "", title, note, loading }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showTyping, setShowTyping] = useState(true);
  const [aiLoading, setAiLoading] = useState(false);

  useEffect(() => {
    if (!loading && companyHistoryData) {
      setDisplayedText("");
      setCurrentIndex(0);
      setShowTyping(true);
    }
  }, [companyHistoryData, loading]);

  useEffect(() => {
    let timeout;
    if (!loading && showTyping && currentIndex < companyHistoryData?.length) {
      setAiLoading(true);
      timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + companyHistoryData[currentIndex]);
        setCurrentIndex((prev) => prev + 1);
      }, 1);
    } else {
      setAiLoading(false);
    }

    return () => clearTimeout(timeout);
  }, [currentIndex, loading, showTyping]);

  return (
    <div className="mt-24 stock-container markdown-content">
      <h2 className="why-title mt-0 mb-16 h4-style">{title}</h2>

      {note && (
        <div className="second-hint mb-16">
          <p className="modal-text">
            <span className="modal-text-span">💡 Disclaimer:</span> This is not
            financial advice. You alone have the authority to determine if a
            stock is suitable for you, and you accept responsibility for any
            trades you make at your brokerage using the tools provided by us or
            our partners.
          </p>
        </div>
      )}
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{displayedText}</ReactMarkdown>
      {loading && (
        <div className="d-flex align-items-center" style={{ marginTop: 10 }}>
          <span className="ai-dot">
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: searchProcessingAnimation,
              }}
              height={80}
              width={80}
            />
          </span>
          <span className="ai-text shimmer">AI Searching...</span>
        </div>
      )}
      {aiLoading && (
        <div className="d-flex align-items-center" style={{ marginTop: 10 }}>
          <span className="ai-dot">
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: typingAnimation,
              }}
              height={30}
              width={30}
              isStopped={false}
              isPaused={false}
            />
          </span>
          <span className="ai-text">AI is Typing</span>
        </div>
      )}
    </div>
  );
};

export default CompanyHistory;
